import { createSelector } from 'reselect'

function _selectRequesting (requestingState, actionTypes) {
  return actionTypes.some(actionType => requestingState[actionType])
}

function _getOfferShowCase (offers, type) {
  return offers[type]
}

export const participant = createSelector(
  state => state.participant,
  participant => participant
)

export const showCaseStoresFilter = createSelector(
  state => state.comunidade.showcase.filters.stores,
  stores => stores
)

export const showCaseStores = createSelector(
  state => state.comunidade.showcase.stores,
  stores => stores
)

export const useLocation = createSelector(
  state => state.comunidade.showcase.useLocation,
  useLocation => useLocation
)

export const zipCode = createSelector(
  state => state.comunidade.showcase.zipCode,
  zipCode => zipCode
)

export const location = createSelector(
  state => state.comunidade.showcase.location,
  location => location
)

export const selectRequesting = createSelector(
  state => state.comunidade.requesting,
  (state, actionTypes) => actionTypes,
  _selectRequesting
)

export const getOffers = createSelector(
  state => state.comunidade.showcase.offers,
  (state, type) => type,
  _getOfferShowCase
)



// WEBPACK FOOTER //
// ./src/features/MeuBairro/selectors.js